<template>


    <d-card-body class="pt-0">
      <div class="card-body p-0 pb-3 text-center mtop responsive-table">
        <table class="table mb-0 mr-4" style="border: 1px #dee2e6 solid;table-layout: fixed;">
          <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Klient</th>
            <th scope="col" class="border-0">Spółka</th>
            <th scope="col" class="border-0">Data płatności</th>
            <th scope="col" class="border-0">Rata</th>
            <th scope="col" class="border-0">Odsetki karne</th>
            <th scope="col" class="border-0" v-if="getUser.is_admin !== 2">Akcja</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="installment in installments" :class="{ 'bg-light-red': (installment.interest_penalty > 0) }">
            <td>
              <dt>Klient</dt>
              <dd>
                <a href="#" @click.prevent="$router.push({name: 'client-edit', params: {id: installment.client_id}})">
                  {{ installment.client_name }} {{ installment.client_last_name }}
                </a>
              </dd>
            </td>
            <td>
              <dt>Spółka</dt>
              <dd>{{ installment.company_name }}</dd>
            </td>
            <td>
              <dt>Data płatności</dt>
              <dd>{{ installment.payment_date.substring(0, 10) }}</dd>
            </td>
            <td>
              <dt>Rata</dt>
              <dd>
                  {{ toNumber(installment.installment_fee) }} zł
                  <ss-popover v-if="installment.installment_ids !== undefined && installment.installment_ids.length > 1">
                      <d-badge theme="danger" class="mr-2 circle-pill" pill><i class="fa fa-exclamation"></i></d-badge>
                      <template slot="tooltip">
                          Ta spłata dotyczy łącznie {{ installment.installment_ids.length }} rat
                      </template>
                  </ss-popover>
              </dd>
            </td>
            <td class="cell-penalty">
              <dt>Odsetki karne</dt>
              <dd>{{ toNumber(installment.interest_penalty) }} zł</dd>
            </td>
            <td v-if="getUser.is_admin !== 2">
              <dt>Akcja</dt>
              <dd v-if="installment.installment_fee === installment.amount_paid">Opłacono</dd>
              <dd v-else class="date-cell-wrapper" >
                <d-button>Opłacono</d-button>
                <ss-date :id="'first_installment_date' + installment.id"
                         @picked="saveInstallment(installment)"
                         type="text"
                         name="first_installment_date"
                         v-model="installment.paid_date"
                         placeholder=""/>
              </dd>

            </td>
          </tr>
          </tbody>
        </table>
        <p v-if="installments.length < 1" class="text-info">Brak nadchodzących płatności.</p>
      </div>
    </d-card-body>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import SsDate from '../common/SsDate'

export default {
  name: 'users-overview',
    components: {
      SsDate
    },
  props: {
    props: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      installments: []
    };
  },
    computed:{
        ...mapGetters([
            'allCompanies',
            'getUser'
        ])
    },
    methods: {
        ...mapActions([
            'getAllCompanies',
        ]),
      toNumber(number){
          return Vue.toNumber(number);
      },
        companyById(id){
            let company = this.allCompanies.length > 0 ? this.allCompanies.find(x => x.id === id) : this.allCompanies.length;
            return company ? company.name : '';
        },
        calculatePenalty(installment){
            let payment_date = new Date(installment.payment_date);
            let paid_date = new Date(installment.paid_date);
            let days_difference = payment_date < paid_date ? (paid_date - payment_date)/(1000 * 60 * 60 * 24) : 0;
            if(days_difference > 0){
                return  days_difference * 0.14 * (installment.capital / 365);
            }
            else{
                return 0;
            }
        },
        fetchData(){
            this.$emit('updateData');
        },
      saveInstallment(installment){
          var self = this;
          setTimeout(function(){
              axios.post('api/schedules/mark-installments-as-paid', installment).then(response => {
                  if (response.data.status === 0) {
                      Vue.swal({
                          type: 'error',
                          title: response.data.message,
                          showConfirmButton: true,
                      }).then(() => {
                          self.fetchData();
                      });
                  } else {
                      Vue.swal({
                          type: 'success',
                          title: 'Rata została opłacona.',
                          showConfirmButton: true,
                      }).then(() => {
                          self.fetchData();
                      });
                  }
              }).catch((errors) =>{
                  console.log(errors);
              })
          }, 500);
      },
    },
  mounted() {
      this.getAllCompanies();
      this.installments = this.props;
  },
  watch: {
    props: {
      handler: function(to) {
        this.installments = to;
      },
      deep: true
    },
  }
};
</script>

<style>
  .mtop{
    margin-top: 15px;
  }
</style>
